<template>
  <div
    v-if="modalVisible"
    id="custom-modal"
    @keydown.escape="closeCard"
  >
    <div class="cache-modal" @click="closeModal"/>
    <transition name="fade" appear>
      <div class="modal-container">
        <div class="close" @click="closeModal">
          <i class="fa fa-close" aria-hidden="true"/>
        </div>
        <slot name="container">
          <slot name="content"/>
          <slot name="sub-content"/>
        </slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: ['modalVisible'],
  methods: {
    closeModal() {
      this.$emit('close-custom-modal', false);
    },
  },
};
</script>
